<template>
  <div class="operations-buttons">
    <button
      v-for="operation in operationTypes"
      :key="operation"
      class="btn btn-success"
      :disabled="getButtonDisableState(operation)"
      @click="saveOperations(operation)"
    >
      <i class="fa fa-fw fa-plus" :class="getIconCss(operation)" />
      Сохранить
      {{ operation === 'arrivals' ? 'приходы' : 'списания' }}
    </button>
  </div>
</template>

<script>
import store from "@/stock/store";
import { operationService } from "@/stock/api-services";
import { useNotification } from "@/_shared/mixins";
import { stockOperationsEntity } from "@/stock/entities/stockOperationsEntity";
const { prepareForInventarization } = stockOperationsEntity;
export default {
  mixins: [useNotification],
  computed: {
    operationTypes() {
      return ['arrivals', 'write_offs'];
    },
    arrivals() {
      return prepareForInventarization('arrivals', this.items);
    },
    write_offs() {
      return prepareForInventarization('write_offs', this.items);
    },
    isLoading() {
      return store.state.inventory.isLoading;
    },
    items() {
      return store.state.inventory.items;
    },
    confirmedOperations() {
      return store.state.inventory.confirmedOperations;
    },
    stockAlertWasShowed() {
      return store.state.inventory.stockAlertWasShowed;
    },
  },
  methods: {
    getIconCss(operation) {
      const modifier = operation === 'arrivals' ? 'plus' : 'minus';
      return [`fa-${modifier}`];
    },
    getButtonDisableState(operation) {
      return this[operation].length < 1
        || this.confirmedOperations.includes(operation)
        || this.isLoading;
    },
    async saveOperations(type = "arrivals") {
      store.commit('inventory/setLoadStatus', true);
      const list = this[type];
      await operationService.confirm(list, type)
        .then((result) => {
          this.showSuccessNotification(result.message);
          store.commit('inventory/addConfirmedOperation', type);
          this.showStockMovementNotification();
        })
        .catch(({ response }) => {
          this.showErrorNotification(response.data.message)
        })
        .finally(() => {
          store.commit('inventory/setLoadStatus', false);
        });
    },
    showStockMovementNotification() {
      if (this.stockAlertWasShowed) {
        return;
      }
      store.commit('inventory/setStockAlertStatus', true);
      const message = 'Теперь вы можете просмотреть добавленные'
        + ' операции на странице "Движение по складу"';
      this.showStandardNotification(message);
    },
  },
};
</script>

<style scoped>
.operations-buttons > .btn:last-child {
  margin-left: 1em;
}
@media (max-width: 1023px) {
  .operations-buttons > .btn:last-child {
    margin-left: 0;
    margin-top: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/stock/features/inventory/OperationsButtons.vue